import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';


export const CreateDotaznik = (props) => {
    const [newDotaznik, setNewDotaznik] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    useEffect(() => {
        if (auth.accessToken === undefined) {
            props.handler(false, "notAuth");
            return;
        }
        let isMounted = true;
        let dotaznikData = props.state.dotaznik;

        const createDotaznik = async () => {
            try {
                const response = await axiosPrivate.post('/dotaznik/createdotaznik', dotaznikData, { maxRedirects: 0 });
                isMounted && setNewDotaznik(response.data);
                props.handler(true, 'created');
            } catch (err) {
                //console.error(err)
                //console.log(err.response.data);
                props.handler(false, 'createError', err.response.data);
            }
        }

        createDotaznik();

        return () => {
            isMounted = false;
        }
    }, [])


    if (newDotaznik !== undefined) {
        return <PostFiles dotaznik={newDotaznik} files={props.state.files} customerType={props.state.dotaznik.kontakt.typZadavatele} email={props.state.dotaznik.kontakt.email} />
    }


}



export const PostFiles = (props) => {
    const [priloha, setPriloha] = useState();
    const axiosPrivate = useAxiosPrivate();
    let allFilesSend = useRef(false);
    const [files, setFiles] = useState(Array.from(props.files));
    if (props.files.length === 0) allFilesSend.current = true;

    useEffect(() => {
        let isMounted = true;
        if (files.length > 0) {
            let nextFile = files.shift();
            let file = new File([nextFile], nextFile.name.normalize());
            let formData = new FormData();
            formData.append('dotaznikId', props.dotaznik.dotaznikId);
            formData.append('typ', nextFile.typ);
            formData.append('files', file);

            const postFiles = async () => {
                try {
                    const response = await axiosPrivate.post('/priloha/post', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        maxRedirects: 0
                    });
                    if (files.length === 0) allFilesSend.current = true;
                    isMounted && setPriloha(response.data);
                } catch (err) {
                    //console.error(err);
                    let errMessage = "Chyba pri nahrani prilohy u dotazniku. Nazev prilohy - " + file.name + ", typ prilohy - " + file.typ;
                    const response = await axiosPrivate.post('/dotaznik/senderrormessage', {}, {
                        params: {
                            subject: "Dotaznik priloha error",
                            text: errMessage
                        }
                        , maxRedirects: 0
                    });
                }
            }

            postFiles();
        }

        return () => {
            isMounted = false;
        }
    }, [priloha])

    if (allFilesSend.current) {
        //return <GetDotaznik dotaznik={props.dotaznik} />
        return <ChangeState dotaznik={props.dotaznik} customerType={props.customerType} email={props.email} />
    }
}



const GetDotaznik = (props) => {
    const [dotaznik, setDotaznik] = useState();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        let isMounted = true;

        const getDotaznik = async () => {
            try {
                const response = await axiosPrivate.get('/dotaznik/get?dotaznikId=' + props.dotaznik.dotaznikId
                    , { maxRedirects: 0 });
                isMounted && setDotaznik(response.data);
            } catch (err) {
                //console.error(err);
            }
        }

        getDotaznik();

        return () => {
            isMounted = false;
        }
    }, [])


    if (dotaznik != undefined) {
        return <ChangeState dotaznik={dotaznik} />
    }
}



const ChangeState = (props) => {
    const [responseStatus, setResponseStatus] = useState();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        let isMounted = true;
        //let state = (!props.dotaznik.dokumentace) ? 4 : 1;
        let state = 1;
        let isGis = false;

        const changeState = async () => {
            try {
                const response = await axiosPrivate.post('/dotaznik/changestate', {}, {
                    params: {
                        dotaznikId: props.dotaznik.dotaznikId,
                        stav: state,
                        gis: isGis
                    }
                    , maxRedirects: 0
                });
                isMounted && setResponseStatus(response.status);
                //isMounted && setDotaznik(response.data);
            } catch (err) {
                //console.error(err);
            }
        }

        changeState();

        return () => {
            isMounted = false;
        }
    }, [])

    if (responseStatus === 200) {
        window.dataLayer = window.dataLayer || [];
        const marketingCookie = document.cookie.split('; ').find(r => r.startsWith('BmiczCookieConsent='));
        const hasMarketing = marketingCookie ? decodeURIComponent(marketingCookie).includes('C0004:1') : false;
        window.dataLayer.push({
            event: 'form_submission_success',
            customerType: props.customerType,
            ...(hasMarketing && { email: props.email }),
        });
        let url = process.env.REACT_APP_ODPOVED_URL + props.dotaznik.dotaznikId;
        document.location = (url);
    }

}
